<div class="col-sm-12">

    <h3 class="text-light-blue">
        Filtro realizado de <b>{{ this.periodoInicial | date:'dd/MM/yyyy' }}</b> até <b>{{ this.periodoFinal
            | date:'dd/MM/yyyy' }}</b>

        <!-- <button class="btn btn-sm btn-danger pull-right"><i class="fa fa-fw fa-file-pdf-o"></i> Gerar relatório</button> -->
        <button class="btn btn-sm btn-danger pull-right" (click)="generateReport()"><i class="fa fa-fw fa-file-pdf-o"></i> Gerar relatório</button>
    </h3>

    <hr>

    <h3>Listas de despesas comuns</h3>
    <hr>

    <div *ngIf="!loading">
        <div class="spinner"></div>
        <p class="text-center" style="color: #777;margin: -70px 0 100px;">Carregando cotações de preço, por favor aguarde ...
        </p>
    </div>

    <div *ngIf="loading">

        <h4 class="text-muted" *ngIf="listaCotacao && listaCotacao.length == 0">Nenhuma cotação de preço encontrada.</h4>

        <div class="col-sm-12">
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <th>Meta/Etapa</th>
                        <th>Despesa</th>
                        <th>Fornecedor</th>
                        <th>Valor</th>
                        <th>Cotações</th>
                        <th>Justificava</th>
                        <th>Data fato</th>
                    </tr>
                    <!-- <tr *ngFor="let item of listaDespesasComuns; let i = index"> -->
                    <tr *ngFor="let item of listaCotacao; let i = index">
                        <td>
                            <ul class="tree">
                                <li>Meta:
                                    {{item.detFisHasDespEtapa}}
                                </li>
                                <li>Etapa:
                                    {{item.detFisHasDespMeta}}
                                </li>
                            </ul>
                        </td>
                        <td>
                            <ul class="tree">
                                <!-- <ng-container *ngFor="let itemDetalhe of item.despesaId?.detalhamentoFisicoHasDespesa"> -->
                                <ng-container *ngFor="let itemDetalhe of item.detFisHasDespEspecificacao">
                                    <li>{{itemDetalhe}}
                                    </li>
                                </ng-container>
                            </ul>
                        </td>
                        <td>
                            <ul class="tree">
                                <li>CPF/CNPJ: {{item.cpfCnpjVencedor}}</li>
                                <li>Nome: {{item.nomeFavorecido}}</li>
                            </ul>
                        </td>
                        <td>{{item.valor | currency:'BRL':'symbol-narrow':'1.2-2'}}</td>
                        <td>
                            <!-- <ng-container *ngFor="let proposta of item.despesaId?.proposta"> -->
                            <ng-container *ngFor="let proposta of item.proposta">
                                <span class="btn btn-xs btn-primary"
                                    (click)="openViewPDF(proposta.hashFile)">{{proposta.proposta}}</span>
                            </ng-container>
                        </td>
                        <td>
                            {{item.justificativaAusenciaProposta}}
                        </td>
                        <td>{{item.dataFatoMovimentacao | date: 'dd/MM/yyyy'}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <br>
        <br>

    </div>

</div>

<p-dialog [style]="{width: '800px', 'min-height': '500px'}" header="Documento" [(visible)]="displayOpenModalView" showEffect="fade"
    [modal]="true">
    <div class="col-sm-12 text-center">
        <div class="embed-container" *ngIf="viewDownload">
            <div class="myIframe">
                <iframe [src]="urlDocumento | safe" frameborder='0'></iframe>
            </div>
        </div>
    </div>
</p-dialog>
